import React, { useState } from 'react';
import { CopyIcon } from '@/shared/icons';

interface CodeBlockProps {
  children: React.ReactNode;
  className?: string;
  language?: string;
}

export const CodeBlock: React.FC<CodeBlockProps> = ({ children, className, language }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    const code = (children as string) || '';
    navigator.clipboard.writeText(code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  // Extract language from className (format: language-xxx)
  const lang = language || className?.replace(/language-/, '') || 'text';

  return (
    <div className="relative group my-4 rounded-xl overflow-hidden bg-grey-light dark:bg-grey-plain-dark border border-grey-plain dark:border-grey-plain-dark">
      {/* Language badge and copy button */}
      <div className="flex items-center justify-between px-4 py-2.5">
        <span className="text-xs font-medium text-grey-hover dark:text-grey-light uppercase tracking-wide">
          {lang}
        </span>
        <button
          onClick={handleCopy}
          className="flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-grey-main dark:text-grey-light hover:text-grey-black dark:hover:text-white transition-colors rounded-md hover:bg-grey-plain dark:hover:bg-grey-hover"
          aria-label="Copy code"
        >
          <CopyIcon className="w-3.5 h-3.5" />
          <span>{copied ? 'Copied!' : 'Copy'}</span>
        </button>
      </div>

      {/* Code block */}
      <pre className="!mt-0 !mb-0 p-4 overflow-auto max-h-[600px]">
        <code
          className={`font-mono text-sm leading-6 text-grey-main dark:text-grey-light ${className ?? ''}`}
        >
          {children}
        </code>
      </pre>
    </div>
  );
};
